import { render, staticRenderFns } from "./TakipDilekceOlusturForm.vue?vue&type=template&id=ca9655c2"
import script from "./TakipDilekceOlusturForm.vue?vue&type=script&lang=ts"
export * from "./TakipDilekceOlusturForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports